export interface VoiceOptionInterface {
  DisplayName: string;
  AzureCode: string;
}
export const VoiceOptions = [
  {
    DisplayName: 'Ava HD',
    AzureCode: 'en-US-Ava:DragonHDLatestNeural',
  },
  {
    DisplayName: 'Bree HD',
    AzureCode: 'en-US-Bree:DragonHDLatestNeural',
  },
  {
    DisplayName: 'Tiana HD',
    AzureCode: 'en-US-Tiana:DragonHDFlashLatestNeural',
  },
  {
    DisplayName: 'Jenny',
    AzureCode: 'en-US-JennyNeural',
  },
  {
    DisplayName: 'Davis',
    AzureCode: 'en-US-DavisNeural',
  },
  {
    DisplayName: 'Elizabeth',
    AzureCode: 'en-US-ElizabethNeural',
  },
  {
    DisplayName: 'Michelle',
    AzureCode: 'en-US-MichelleNeural',
  },
  {
    DisplayName: 'Andrew',
    AzureCode: 'en-US-AndrewNeural',
  },
];
